import React, { useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";
import BedroomBabyOutlinedIcon from "@mui/icons-material/BedroomBabyOutlined";
import RecyclingOutlinedIcon from "@mui/icons-material/RecyclingOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import EmojiEmotionsOutlinedIcon from "@mui/icons-material/EmojiEmotionsOutlined";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import Diversity1OutlinedIcon from "@mui/icons-material/Diversity1Outlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F5F5F5" }}>
      {/* About Us Section - White Background */}
      <Box sx={{ maxWidth: "1440px" }}>
        <Box
          sx={{
            backgroundColor: "#ffffff",

            py: 8,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              maxWidth: "830px",
              width: "100%",
              px: 2,
              "@media (max-width: 1200px)": {
                maxWidth: "820px",
              },
            }}
          >
            <Typography
              variant="h1"
              component="h1"
              sx={{
                fontSize: "36px",
                fontWeight: 700,
                textAlign: "center",
                mb: 4,
                color: "#000000",
                "@media (max-width: 856px)": {
                  fontSize: "30px",
                },
              }}
            >
              About Us
            </Typography>

            <Typography
              variant="h2"
              sx={{
                fontSize: "16px",
                fontWeight: 700,
                textAlign: "center",
                mb: 3,
                color: "#000000",
              }}
            >
              R3PLAY is where nostalgia meets technology — and where toys get a
              second life.
            </Typography>

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                textAlign: "center",
                mb: 2,
                color: "#666666",
                lineHeight: 1.6,
              }}
            >
              We're building a joyful social commerce platform for toy lovers,
              collectors, parents, kidults, and anyone who still lights up at
              the sight of their favorite childhood treasures.
            </Typography>

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                textAlign: "center",
                mb: 2,
                color: "#666666",
                lineHeight: 1.6,
              }}
            >
              Born from a decade-long real-world problem and fueled by heart,
              imagination, and community, R3PLAY is more than a marketplace.
              It's a place to buy, sell, trade, and donate toys and collectibles
              — and share the stories behind them.
            </Typography>

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                textAlign: "center",
                mb: 2,
                color: "#666666",
                lineHeight: 1.6,
              }}
            >
              We believe toys carry energy. Memories. Magic.
            </Typography>

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                textAlign: "center",
                mb: 2,
                color: "#666666",
                lineHeight: 1.6,
              }}
            >
              And when they get a chance to be relived, reused, and R3PLAYed,
              something beautiful happens.
            </Typography>

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                textAlign: "center",
                mb: 1,
                color: "#666666",
                lineHeight: 1.6,
              }}
            >
              This is play... with soul.
            </Typography>

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                textAlign: "center",
                mb: 1,
                color: "#666666",
                lineHeight: 1.6,
              }}
            >
              This is nostalgia... with technology.
            </Typography>

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                textAlign: "center",
                color: "#666666",
                lineHeight: 1.6,
              }}
            >
              This is R3PLAY.
            </Typography>
          </Box>
        </Box>

        {/* Our Vision Section - Gray Background */}
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            py: 8,
            px: 2
          }}
        >
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: "36px",
              fontWeight: 700,
              textAlign: "center",
              mb: 3,
              color: "#000000",
              "@media (max-width: 856px)": {
                fontSize: "30px",
              },
            }}
          >
            Our Vision
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 400,
              textAlign: "center",
              color: "#666666",
              lineHeight: 1.6,
            }}
          >
            Where nostalgia, technology, and community come to play.
          </Typography>
        </Box>

        {/* Our Mission Section - White Background */}
        <Box sx={{ backgroundColor: "#ffffff", py: 8 }}>
          <Box
            sx={{
              width: "100%",
              px: "100px",
              "@media (max-width: 1200px)": {
                px: "16px",
              },
            }}
          >
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: "36px",
                fontWeight: 700,
                textAlign: "center",
                mb: 2,
                color: "#000000",
                "@media (max-width: 856px)": {
                  fontSize: "30px",
                },
              }}
            >
              Our Mission
            </Typography>

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                textAlign: "center",
                color: "#666666",
                lineHeight: 1.6,
                mb: 6,
              }}
            >
              To reconnect people with the joy of play while building a more
              sustainable, community-driven future for toys.
            </Typography>

            {/* Icons Grid */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 6,
                mb: 4,
                "@media (max-width: 1200px)": {
                  gap: 3,
                  flexWrap: "wrap",
                },
                "@media (max-width: 856px)": {
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 6,
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  pb: 2,
                  px: 3,
                },
              }}
            >
              {/* Revive nostalgia */}
              <Box
                sx={{
                  textAlign: "center",
                  width: "292px",
                  px: "20px",
                  "@media (max-width: 1200px)": {
                    width: "182px",
                    px: "10px",
                  },
                  "@media (max-width: 856px)": {
                    width: "100%",
                    px: 0,
                    pb: 2,
                  },
                }}
              >
                <Box
                  sx={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "50%",
                    backgroundColor: "#FFE5E5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px",
                  }}
                >
                  <BedroomBabyOutlinedIcon
                    sx={{ fontSize: 32, color: "#E53935" }}
                  />
                </Box>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    mb: 1,
                    color: "#000000",
                  }}
                >
                  Revive nostalgia
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#666666",
                    lineHeight: 1.5,
                  }}
                >
                  and celebrate the emotional stories behind every toy.
                </Typography>
              </Box>

              {/* Reduce waste */}
              <Box
                sx={{
                  textAlign: "center",
                  width: "292px",
                  px: "20px",
                  "@media (max-width: 1200px)": {
                    width: "182px",
                    px: "10px",
                  },
                  "@media (max-width: 856px)": {
                    width: "100%",
                    px: 0,
                    pb: 2,
                  },
                }}
              >
                <Box
                  sx={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "50%",
                    backgroundColor: "#FFE5E5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px",
                  }}
                >
                  <RecyclingOutlinedIcon
                    sx={{ fontSize: 32, color: "#E53935" }}
                  />
                </Box>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    mb: 1,
                    color: "#000000",
                  }}
                >
                  Reduce waste
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#666666",
                    lineHeight: 1.5,
                  }}
                >
                  by extending the life of toys through resale, trade, and
                  donation.
                </Typography>
              </Box>

              {/* Rebuild community */}
              <Box
                sx={{
                  textAlign: "center",
                  width: "292px",
                  px: "20px",
                  "@media (max-width: 1200px)": {
                    width: "182px",
                    px: "10px",
                  },
                  "@media (max-width: 856px)": {
                    width: "100%",
                    px: 0,
                    pb: 2,
                  },
                }}
              >
                <Box
                  sx={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "50%",
                    backgroundColor: "#FFE5E5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px",
                  }}
                >
                  <HubOutlinedIcon sx={{ fontSize: 32, color: "#E53935" }} />
                </Box>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    mb: 1,
                    color: "#000000",
                  }}
                >
                  Rebuild community
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#666666",
                    lineHeight: 1.5,
                  }}
                >
                  around shared childhood memories and the magic of collecting.
                </Typography>
              </Box>

              {/* Reimagine the way we buy and sell */}
              <Box
                sx={{
                  textAlign: "center",
                  width: "292px",
                  px: "20px",
                  "@media (max-width: 1200px)": {
                    width: "182px",
                    px: "10px",
                  },
                  "@media (max-width: 856px)": {
                    width: "100%",
                    px: 0,
                  },
                }}
              >
                <Box
                  sx={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "50%",
                    backgroundColor: "#FFE5E5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px",
                  }}
                >
                  <LocalMallOutlinedIcon
                    sx={{ fontSize: 32, color: "#E53935" }}
                  />
                </Box>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    mb: 1,
                    color: "#000000",
                  }}
                >
                  Reimagine the way we buy and sell
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#666666",
                    lineHeight: 1.5,
                  }}
                >
                  through joyful technology and authentic connection.
                </Typography>
              </Box>
            </Box>

            {/* Bottom Text */}
            <Box sx={{ textAlign: "center", mt: 4 }}>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#666666",
                  lineHeight: 1.6,
                }}
              >
                At R3PLAY, every toy has a story.
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#666666",
                  lineHeight: 1.6,
                }}
              >
                And every story deserves a second chapter.
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Our Values Section - Gray Background */}
        <Box sx={{ backgroundColor: "#f5f5f5", py: 8 }}>
          <Box
            sx={{
              px: "100px",
              "@media (max-width: 1200px)": {
                px: "16px",
              },
            }}
          >
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: "36px",
                fontWeight: 700,
                textAlign: "center",
                mb: 6,
                color: "#000000",
                "@media (max-width: 856px)": {
                  fontSize: "30px",
                },
              }}
            >
              Our Values
            </Typography>

            {/* Cards Container */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 3,
                flexWrap: "wrap",
                margin: "0 auto",
                maxWidth: "1270px",
                "@media (max-width: 1200px)": {
                  maxWidth: "820px",
                },
              }}
            >
              {/* Joy */}
              <Box
                sx={{
                  width: "390px",
                  height: "124px",
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  px: 3,
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: "56px",
                    height: "56px",
                    minWidth: "56px",
                    borderRadius: "50%",
                    backgroundColor: "#FAFAFA",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <EmojiEmotionsOutlinedIcon
                    sx={{ fontSize: 28, color: "#E53935" }}
                  />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 700,
                      mb: 0.5,
                      color: "#000000",
                    }}
                  >
                    Joy
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#666666",
                      lineHeight: 1.4,
                    }}
                  >
                    because play is essential at any age.
                  </Typography>
                </Box>
              </Box>

              {/* Connection */}
              <Box
                sx={{
                  width: "390px",
                  height: "124px",
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  px: 3,
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: "56px",
                    height: "56px",
                    minWidth: "56px",
                    borderRadius: "50%",
                    backgroundColor: "#FAFAFA",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <HubOutlinedIcon sx={{ fontSize: 28, color: "#E53935" }} />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 700,
                      mb: 0.5,
                      color: "#000000",
                    }}
                  >
                    Connection
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#666666",
                      lineHeight: 1.4,
                    }}
                  >
                    because memories bind us.
                  </Typography>
                </Box>
              </Box>

              {/* Creativity */}
              <Box
                sx={{
                  width: "390px",
                  height: "124px",
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  px: 3,
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: "56px",
                    height: "56px",
                    minWidth: "56px",
                    borderRadius: "50%",
                    backgroundColor: "#FAFAFA",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <TipsAndUpdatesOutlinedIcon
                    sx={{ fontSize: 28, color: "#E53935" }}
                  />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 700,
                      mb: 0.5,
                      color: "#000000",
                    }}
                  >
                    Creativity
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#666666",
                      lineHeight: 1.4,
                    }}
                  >
                    because imagination is our superpower.
                  </Typography>
                </Box>
              </Box>
              {/* Sustainability */}
              <Box
                sx={{
                  width: "390px",
                  height: "124px",
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  px: 3,
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: "56px",
                    height: "56px",
                    minWidth: "56px",
                    borderRadius: "50%",
                    backgroundColor: "#FAFAFA",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <RecyclingOutlinedIcon
                    sx={{ fontSize: 28, color: "#E53935" }}
                  />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 700,
                      mb: 0.5,
                      color: "#000000",
                    }}
                  >
                    Sustainability
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#666666",
                      lineHeight: 1.4,
                    }}
                  >
                    because toys deserve a longer life.
                  </Typography>
                </Box>
              </Box>

              {/* Community */}
              <Box
                sx={{
                  width: "390px",
                  height: "124px",
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  px: 3,
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: "56px",
                    height: "56px",
                    minWidth: "56px",
                    borderRadius: "50%",
                    backgroundColor: "#FAFAFA",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Diversity1OutlinedIcon
                    sx={{ fontSize: 28, color: "#E53935" }}
                  />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 700,
                      mb: 0.5,
                      color: "#000000",
                    }}
                  >
                    Community
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#666666",
                      lineHeight: 1.4,
                    }}
                  >
                    because R3PLAY is built for people who feel.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Founders Bios Section - White Background */}
        <Box
          sx={{
            backgroundColor: "#ffffff",
            py: 8,

            minHeight: "187px",
            "@media (max-width: 1200px)": {
              minHeight: "131px",
            },
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              px: "100px",
              "@media (max-width: 1200px)": {
                px: "16px",
              },
            }}
          >
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: "36px",
                fontWeight: 700,
                textAlign: "center",
                color: "#000000",
                "@media (max-width: 856px)": {
                  fontSize: "30px",
                },
              }}
            >
              Founders Bios
            </Typography>
          </Box>
        </Box>

        {/* Sustainability & Impact Section - Gray Background */}
        <Box sx={{ backgroundColor: "#f5f5f5", py: 8 }}>
          <Box
            sx={{
              px: "100px",
              "@media (max-width: 1200px)": {
                px: "16px",
              },
            }}
          >
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: "36px",
                fontWeight: 700,
                textAlign: "center",
                mb: 2,
                color: "#000000",
                "@media (max-width: 856px)": {
                  fontSize: "30px",
                },
              }}
            >
              Sustainability & Impact
            </Typography>

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                textAlign: "center",
                color: "#666666",
                lineHeight: 1.6,
                mb: 6,
              }}
            >
              At R3PLAY, sustainability is more than a trend — it's our
              foundation.
            </Typography>

            {/* Impact Cards */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 3,
                mb: 4,
                "@media (max-width: 856px)": {
                  flexDirection: "column",
                  alignItems: "center",
                },
              }}
            >
              {/* Card 1 - Recycling */}
              <Box
                sx={{
                  width: "381px",
                  "@media (max-width: 856px)": {
                    width: "361px",
                  },
                  height: "188px",
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  px: 3,
                  py: 3,
                }}
              >
                <Box
                  sx={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "50%",
                    backgroundColor: "#FAFAFA",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <RecyclingOutlinedIcon
                    sx={{ fontSize: 28, color: "#E53935" }}
                  />
                </Box>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    textAlign: "center",
                    color: "#000000",
                    lineHeight: 1.4,
                  }}
                >
                  Millions of toys end up in landfills each year
                </Typography>
              </Box>

              {/* Card 2 - Favorite */}
              <Box
                sx={{
                  width: "381px",
                  "@media (max-width: 856px)": {
                    width: "361px",
                  },
                  height: "188px",
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  px: 3,
                  py: 3,
                }}
              >
                <Box
                  sx={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "50%",
                    backgroundColor: "#FAFAFA",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <FavoriteBorderOutlinedIcon
                    sx={{ fontSize: 28, color: "#E53935" }}
                  />
                </Box>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    textAlign: "center",
                    color: "#000000",
                    lineHeight: 1.4,
                  }}
                >
                  Countless childhood treasures sit forgotten in closets
                </Typography>
              </Box>

              {/* Card 3 - Delete */}
              <Box
                sx={{
                  width: "381px",
                  "@media (max-width: 856px)": {
                    width: "361px",
                  },
                  height: "188px",
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  px: 3,
                  py: 3,
                }}
              >
                <Box
                  sx={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "50%",
                    backgroundColor: "#FAFAFA",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <DeleteOutlinedIcon sx={{ fontSize: 28, color: "#E53935" }} />
                </Box>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    textAlign: "center",
                    color: "#000000",
                    lineHeight: 1.4,
                  }}
                >
                  Families struggle with clutter and waste
                </Typography>
              </Box>
            </Box>

            {/* Bottom Text */}
            <Box
              sx={{
                textAlign: "center",
                mt: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "#000000",
                  lineHeight: 1.6,
                  mb: 1,
                }}
              >
                R3PLAY helps solve all three.
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#666666",
                  lineHeight: 1.6,
                  maxWidth: "747px",
                }}
              >
                By giving toys a second chapter, we reduce waste, encourage
                circular play, and build a culture of mindful consumption —
                without losing the magic.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutUs;
